import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-wbmchlorides-vertical',
  standalone: false,
  templateUrl: './wbmchlorides-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class WbmchloridesVerticalComponent {

    @Input() wbmchloridesTest: any;
}
   